// 由于agentid和group的id都是纯数字，所有可能出现id相同的情况，为了避免此类问题的发送，增加一个value字段确定是组还是客服
const getGroupTreeList = (agentList = [], groupList = []) => {
  const data = [];
  const allList = [];
  groupList.forEach(g => {
    const children = agentList
      .filter(a => a.group_id === g.id && a.email && !a.deleted_at)
      .map(a => {
        allList.push({
          ...a,
          title: a.realname || a.nickname,
          key: a.id,
          value: `agent::${a.id}`
        });
        return {
          ...a,
          title: a.realname || a.nickname,
          key: a.id,
          value: `agent::${a.id}`
        };
      });
    if (children && children.length > 0) {
      allList.push({
        ...g,
        title: g.name,
        key: g.id,
        value: `group::${g.id}`
      });
      data.push({
        ...g,
        title: g.name,
        key: g.id,
        value: `group::${g.id}`,
        children
      });
    }
  });
  return {
    treeList: data,
    allList
  };
};

const getValueIdList = (valueList = []) => {
  const data = {
    agentList: [],
    groupList: []
  };
  let tempList = valueList;
  if (!Array.isArray(valueList)) {
    tempList = [valueList];
  }
  tempList.forEach(value => {
    const list = value.split('::');
    if (list[0] === 'agent') {
      data.agentList.push(+list[1]);
    } else if (list[0] === 'group') {
      data.groupList.push(+list[1]);
    }
  });
  return data;
};

export { getGroupTreeList, getValueIdList };
